import { writable } from 'svelte/store';
import collect from 'collect.js';
import config from '@/config';
import { mergeOrAddModelDataInCollectionStore } from '@/Stores/StoreHelpers';
import DerivedMarketTemplate from '@/Models/DerivedMarketTemplate.js';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	const { subscribe, set, update } = writable(collect([]));

	const methods = {
		getDerivedMarketTemplatesForSport(sportId) {
			if (!config.SPORT_ENABLED) return;

			const derivedMarketTemplate = new DerivedMarketTemplate();
			let results = derivedMarketTemplate.getBySportId(sportId);
			return results
				.then((result) => {
					set(collect(result.data));
				})
				.catch((e) => {
					console.error(e);
				});
		},

		getDerivedMarketTemplate(derivedMarketTemplateId) {
			if (!config.SPORT_ENABLED) return;

			const derivedMarketTemplate = new DerivedMarketTemplate();

			return derivedMarketTemplate
				.with([])
				.find(derivedMarketTemplateId)
				.then((result) => {
					return result;
				});
		},

		newDerivedMarketTemplate(sport) {
			// Look for an existing "new" group that never got persisted and wipe whatever data it has
			let foundExisting = false;
			update((derivedMarketTemplates) => {
				derivedMarketTemplates = derivedMarketTemplates.transform((derivedMarketTemplate) => {
					if (derivedMarketTemplate.id == 'create') {
						derivedMarketTemplate.name = null;
						derivedMarketTemplate.sport = sport;
						derivedMarketTemplate.parent_market = null;
						derivedMarketTemplate.pricing_matrix = null;
						foundExisting = true;
					}
					return derivedMarketTemplate;
				});
				return derivedMarketTemplates;
			});
			// Assuming there isn't one already existing create a new one
			if (!foundExisting) {
				let derivedMarketTemplate = new DerivedMarketTemplate();
				derivedMarketTemplate = derivedMarketTemplate.hydrate({
					id: 'create',
					name: null,
					sport: sport,
					parent_market: null,
					pricing_matrix: null
				});
				mergeOrAddModelDataInCollectionStore(derivedMarketTemplate, this);
			}
		},

		createDerivedMarketTemplate(sportId, derivedMarketTemplateData) {
			const derivedMarketTemplate = new DerivedMarketTemplate();

			return derivedMarketTemplate
				.makePersistRequest({
					url: derivedMarketTemplate.resourceUrl(),
					method: 'POST',
					data: derivedMarketTemplateData
				})
				.then((result) => {
					this.getDerivedMarketTemplatesForSport(sportId);
					return result;
				});
		},
		updateDerivedMarketTemplate(derivedMarketTemplate, overrideFormData = {}) {
			return derivedMarketTemplate
				.makePersistRequest({
					url: derivedMarketTemplate.selfUrl(),
					method: 'PATCH',
					data: derivedMarketTemplate.preparePayload(overrideFormData)
				})
				.then((result) => {
					this.getDerivedMarketTemplatesForSport(derivedMarketTemplate.sport.id);
					return result;
				});
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
